import React , {useEffect, useState} from 'react';
import { useNavigate, Link } from "react-router-dom";
import '../assets/css/animate.css';
import '../assets/css/font-awesome.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faGooglePlusG } from '@fortawesome/free-brands-svg-icons';
import curonext from '../assets/img/CuronextFinal.png';
import '../assets/css/bootstrap.min.css';  
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants' 
import {EmailOTPTeamName} from '../common/constants' 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/css/login.css';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
 



  function DeleteAccount() {
    const history = useNavigate();
    const [Loading, setLoading] = useState(false);
    const [EmailPhone, setEmailPhone] = useState("");
    const [ProductFactor, setProductFactor] = useState("");
    const [Password, setPassword] = useState("");
    const [OTP, setOTP] = useState("");
    const [Disable, setDisable] = useState(true);
    const [DisableOTP, setDisableOTP] = useState(true);
    const [ShowHide, setShowHide] = useState(false);
    const [OTPMatch, setOTPMatch] = useState("");
    const [LoginData, setLoginData] = useState("");
    const [DeleteModal, setDeleteModal] = useState(false);
    // const [passwordInput, setPasswordInput] = React.useState("");
    // const onPasswordChange = (e) => {
    //   setPasswordInput(e.target.value);
    // };

    // const toggle = () => {
    //   if (password === "password") {
    //     setPasswordValue("text");
    //     return;
    //   }
    //   setPasswordValue("password");
    // };

    // const notify = () => toast.success("Wow so easy!");

    

    const ProductApi = async () => {
        try {
            setLoading(true);
            let response = await commonAPI("CuroProducts")
            if (response.success===true){
                // console.log("Table", response)
                const productName = response.data.filter((products, index) => {
                    return products.productName.toUpperCase() === "CURONEXT"
                  })
                //   console.log(productName)
                  setProductFactor(productName[0].primeProductCode)
                //   console.log(productName[0].primeProductCode)
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                // alert("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": "", // Need to be change
                "mobileNumber": "", // Need to be change
                "requestJSON": "",
                "uri": "/api/Common/CuroProducts",
                "errorNumber": "CP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Login.js",
                "functionName": "ProductApi",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
            
        }

    }

    useEffect(() => {
        ProductApi();
    }, [])

    useEffect(() => {
        if((EmailPhone.length > 9 || EmailPhone.includes("@"))){
            setDisable(false);
        }else{
            setDisable(true);
        }
    }, [EmailPhone])

    useEffect(() => {
        if(OTP.length > 5){
            setDisableOTP(false);
        }else{
            setDisableOTP(true);
        }
    }, [OTP])


    const LoginApi = async () => {
        const bodydata = { 
            "userId": EmailPhone,
            "userPassword": Password
        };
        try {
            const userDataString = localStorage.getItem("primeProductCode");
            const PrimeProductCode = JSON.parse(userDataString);
            if(!EmailPhone){
                toast.warning("Please Enter Email / Mobile No")
            }else{
                let response = await commonAPI("PortalLogin", bodydata)
                
                // console.log("Login Response", response)
                if(response?.success == true && response?.message.length == 0){
                    // alert("User Added"); 
                    setLoginData(response?.data) ;
                    // console.log(response.data)
                    console.log("primefactorcode222222", response?.data)
                    if(response?.data?.productAccessFactor % ProductFactor == 0){
                        const bodyData = { 
                            "userId": response?.data?.userId,
                            "userImageRequired": true,
                            "buildingLogoRequired": true
                          };
                        // if (EmailPhone.includes("@")){
                            let responseMapping = await commonAPI("GetCuroNextUserMapping", bodyData)
            
                            // console.log("Login Response", response)
                            if(responseMapping?.success == true && responseMapping?.message.length == 0){
                                // alert("User Added"); 
                                console.log("Portal Login", response)
                                console.log("responseMapping",responseMapping)
                                if (responseMapping?.data?.length == 1 && responseMapping?.data[0]?.currentStatus.toUpperCase() == "APPROVED"){
                                    console.log("Approved", responseMapping)
                                    if(responseMapping?.data[0]?.roleName == "Support Admin"){
                                        if (!responseMapping?.data[0].isActive && !responseMapping?.data[0]?.isActiveUser){
                                            toast.error("Your account is inactive");
                                        }else if (!responseMapping?.data[0]?.isActiveBuilding){
                                            toast.error("Your building is inactive");
                                        }else if (!responseMapping?.data[0]?.isActiveClient){
                                            toast.error("Your client is inactive");
                                        }else{
                                            const dataToUpdate = {
                                                ...response?.data,
                                                loginCount : 1,
                                                // loginMessage : 1,
                                                familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                userMappingId: responseMapping?.data[0]?.userMappingId,
                                                buildingId: responseMapping?.data[0]?.buildingId,
                                                buildingName: responseMapping?.data[0]?.buildingName,
                                                flatId: responseMapping?.data[0]?.flatId,
                                                flatName: responseMapping?.data[0]?.flatName,
                                                roleId: responseMapping?.data[0]?.roleId,
                                                roleName: responseMapping?.data[0]?.roleName,
                                                IsParent: responseMapping?.data[0]?.IsParent,
                                                currentStatus: responseMapping?.data[0]?.currentStatus,
                                                familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                isActiveBuilding: responseMapping?.data[0]?.isActiveBuilding,
                                                isActiveClient: responseMapping?.data[0]?.isActiveClient,
                                                isActiveRole: responseMapping?.data[0]?.isActiveRole,
                                                isActiveUser: responseMapping?.data[0]?.isActiveUser,
                                                isActive: responseMapping?.data[0]?.isActive,
                                                logo: responseMapping?.data[0]?.logo,
                                                addressLine1: responseMapping?.data[0]?.addressLine1,
                                                addressLine2: responseMapping?.data[0]?.addressLine2,
                                                city: responseMapping?.data[0]?.city,
                                                state: responseMapping?.data[0]?.state
                                            }
                                            console.log("dataToUpdate1111", dataToUpdate);
                                            console.log("data Mapping", responseMapping);
                                            localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                                            // toast.success("Login Successfully");
                                            
                                            history('/Dashboard');
                                            
                                        }
                                    }else {
                                        if (!responseMapping?.data[0]?.isActive && !responseMapping?.data[0]?.isActiveUser){
                                            toast.error("Your account is inactive");
                                        }else if (!responseMapping?.data[0]?.isActiveBuilding){
                                            toast.error("Your building is inactive");
                                        }else if (!responseMapping?.data[0]?.isActiveClient){
                                            toast.error("Your client is inactive");
                                        }else{
                                            const dataToUpdate = {
                                                ...response?.data,
                                                loginCount : 1,
                                                // loginMessage : 1,
                                                familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                userMappingId: responseMapping?.data[0]?.userMappingId,
                                                buildingId: responseMapping?.data[0]?.buildingId,
                                                buildingName: responseMapping?.data[0]?.buildingName,
                                                flatId: responseMapping?.data[0]?.flatId,
                                                flatName: responseMapping?.data[0]?.flatName,
                                                roleId: responseMapping?.data[0]?.roleId,
                                                roleName: responseMapping?.data[0]?.roleName,
                                                IsParent: responseMapping?.data[0]?.IsParent,
                                                currentStatus: responseMapping?.data[0]?.currentStatus,
                                                familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                isActiveBuilding: responseMapping?.data[0]?.isActiveBuilding,
                                                isActiveClient: responseMapping?.data[0]?.isActiveClient,
                                                isActiveRole: responseMapping?.data[0]?.isActiveRole,
                                                isActiveUser: responseMapping?.data[0]?.isActiveUser,
                                                isActive: responseMapping?.data[0]?.isActive,
                                                logo: responseMapping?.data[0]?.logo,
                                                addressLine1: responseMapping?.data[0]?.addressLine1,
                                                addressLine2: responseMapping?.data[0]?.addressLine2,
                                                city: responseMapping?.data[0]?.city,
                                                state: responseMapping?.data[0]?.state
                                            }
                                            console.log("dataToUpdate2222", dataToUpdate);
                                            console.log("data Mapping", responseMapping);
                                            localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                                            // toast.success("Login Successfully");
                                            history('/Dashboard');

                                        }
                                    }
                                    
                                }else{
                                    // console.log("NotApproved", responseMapping)
                                    // toast.warning(response?.message[0]);
                                    toast.error("Your status is pending");
                                }
                            }
                            // console.log("this is email")
                        // }else{
                        //     MobileOtpApi();
                        //     setShowHide(true);
                        //     // console.log("this is Mobile number");
                        // }
                    }else{
                        toast.warning("You are not authorized user");
                        // alert("You are not authorized user");
                    }
                    // setShowHide(false)
                }else{
                    // alert(response.message[0]);
                    toast.error(response.message[0]);
                    setShowHide(false);
                }
            }    
            
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": "", // Need to be change
                "mobileNumber": EmailPhone, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/Notice",
                "errorNumber": "LG01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Login.js",
                "functionName": "LoginApi",
            });
            console.log("body",bodyError)
            let response = await commonAPI("ErrorLogMaster", bodyError)
            
           console.log(response)
            if(response?.success === true && response?.message.length == 0){
                // alert("Something went wrong");
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }
        
          
          
    }
    useEffect(() => {
        const handleKeyDown = (event) => {
            if(!Disable){
                if (event.key === 'Enter') {
                    LoginApi()
                    // Perform your action here
                    // console.log(edit,editFlat)
                    // if(!edit || !editFlat){
                    //     saverOwnerShipData()
                    // }


                }
            }    
        };

        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [EmailPhone]);

    // useEffect(() => {
    //     const storedUsername = localStorage.getItem('userData');
    //     console.log("useEffect Local storage name", storedUsername)
    //     if (storedUsername) {
    //       // If the username is present, redirect to the dashboard
    //       history('/Dashboard');
    //       console.log("useEffect Local storage Yes")    
    //     }
    //     else if(storedUsername===null){
    //         history('/');
    //         console.log("useEffect Local storage No")    
    //     }
    // }, [history]);

    const MobileOtpApi = async () => {
        const bodydata = { 
            "templateKey": "OTP",
            "smsTo": EmailPhone,
            "appSource": "CuroNext",
            "placeHolderList": {
                "{#appname#}": "CuroNext",
                "{#otp#}": ""
            }
        };
        try {
            if(!EmailPhone){
                toast.error("Please enter mobile number");
                // alert("Please enter mobile number");
            }else{
                // console.log("body", bodydata);
                let response = await commonAPI("MobileOTP", bodydata)
                console.log("otp response", response.data);
                if(response.success == true & response.message.length == 0){
                    // alert("OTP sent to your mobile number");  
                    // toast.success(`OTP sent to your mobile number ${EmailPhone}`);
                    setOTPMatch(response.data)
                    setShowHide(true)
                }else{
                    toast.error(response.message[0]);
                    setShowHide(false)
                }
            }
            
        } catch (error) {
            setLoading(false);
            const bodyError = { 
                "errorLogId": 0, // Need to be change
                "userId": 2, // Need to be change
                "mobileNumber": "", 
                "requestJSON": bodydata,
                "uri": "/api/Notification/MobileOTP",
                "errorNumber": "POTP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Registration.js",
                "functionName": "OtpApi",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }
        
          
          
    }


    const matchOTP = async () => {
        try {
            // const bodyData =
            // {
            // "userId": EmailPhone,
            // }
            console.log("OTP", OTPMatch, OTP)
            if (OTPMatch == OTP){
                // alert("OTP Matched");
                setLoading(false);
                setDeleteModal(true)
                // setShowHide(false);
                // const userDataString = localStorage.getItem("userData");
                // const userData = JSON.parse(userDataString);
                // updating the user data
                // let response = await commonAPI("DeleteAccount", bodyData)
            
                // console.log("DeleteAccount Response", response)
                // if(response.success == true & response.message.length == 0){
                //     // alert("User Added"); 
                //     toast.success("Account Deleted");
                //     setEmailPhone("")
                //     setOTP("")
                //     setLoading(false);
                // }else{
                //     toast.error(response.message[0]);
                //     setLoading(false);
                //     setOTP("")
                //     setEmailPhone("")
                // }
                
                // MappingApi();
                // history('/NoticeApproval');
                return
                const myuserData = {LoginCountData:{LoginCount : 1}, LoginData};
                localStorage.setItem("userData", JSON.stringify(myuserData));
                const auth = localStorage.getItem("userData");
                const userGetdata = JSON.parse(auth);
                console.log("myUserData", userGetdata)
                
            }else{
                toast.error("Please enter vaild otp");
                // alert("Please enter vaild otp");
                setShowHide(true);
                setLoading(false);
            }
        } catch (error) {
            
        }
        
    }

    const DeleteAccountApi = async () => {
        try {
            const bodyData =
            {
            "mobileNumber": EmailPhone,
            }
            
                let response = await commonAPI("DeleteAccount", bodyData)
            
                console.log("DeleteAccount Response", response, bodyData)
                if(response.success == true & response.message.length == 0){
                    toast.success("Account Deleted");
                    setShowHide(false);
                    setDeleteModal(false)
                    setEmailPhone("")
                    setOTP("")
                    setLoading(false);
                }else{
                    toast.error(response.message[0]);
                    setLoading(false);
                    setOTP("")
                    setEmailPhone("")
                }
                
            
        } catch (error) {
            
        }
        
    }

    return ( 
             <>
               {Loading? 
                    <div className="loaderDiv" style={{top: 0}}>
                        <div className="loader" ></div>
                    </div> 
                :null}
               <div className="login-register" style={{backgroundImage: "none"}}>

                <ToastContainer />

                <Modal centered show={DeleteModal} onHide={() =>
                        setDeleteModal(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="row px-3" id="validation">
                                <div className="col-12 bg-white pt-3 pb-2">
                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                        <div className="FnFtxt">
                                            {/* <h2> Delete {CheckPosition}</h2> */}
                                            <h3> Are you sure you want to delete your account? This action is permanent and cannot be undone. You will lose all your data and access to your account. </h3>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                <div className='both_ConfrmBTN col-6' onClick={DeleteAccountApi}>
                                    <Button variant="danger">Delete Account</Button>{' '}
                                </div>
                                <div className='both_ConfrmBTN col-6' onClick={() => setDeleteModal(false)} >
                                    <Button variant="light"> Cancel</Button>{' '}
                                </div>
                            </div>
                        </Modal.Body>

                    </Modal>
               {ShowHide ? 
               <div className="container">
                 <div className="row">
                      <div className="col-lg-5 col-sm-12 col-12 m-auto">

                    <div className="login-box card">
                        <div className="card-body">
                            <div className="form-horizontal form-material">
                                <div className='col-12 text-center'>
                                    <img src={curonext} className='img img-responsive img-fluid logo-width mt-0 mb-2'/>
                                </div>    
                            <h3 className="signin_login text-center">OTP has been sent to mobile number - {EmailPhone}</h3>
                                <div className="form-group login-btm">
                                    <div className="col-xs-12">
                                        <div className="label-float">
                                            <input type="number" value={OTP} onChange={(e) => {setOTP(e.target.value);}} placeholder=" "/>
                                            <label>Enter OTP</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="text-center">
                                    <div className="col-xs-12 p-b-20">
                                        <button className="btn btn-block btn-lg btn-info btn-rounded text-white m-auto" type='button' onClick={matchOTP} disabled={DisableOTP} >Sumbit OTP</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div> 
                </div>
                    </div>
                 </div>
                    :    
                    <div className='container'>
                        <div className='row'>
                              <div className="col-lg-5 col-sm-12 col-12 m-auto">  
                       <div className="login-box card">
                        <div className="card-body">
                            <div className="form-horizontal form-material text-center">
                                <img src={curonext} className='img img-responsive img-fluid logo-width mt-0 mb-2'/>
                                <h3 className="signin_login">Delete Account</h3>
                                <div className="form-group">
                                    <div className="col-xs-12">
                                        <div className="label-float mb-3">
                                            <input type="number" onChange={(e) => {setEmailPhone(e.target.value)}} value={EmailPhone} />
                                            <label>Mobile Number</label>
                                        </div>
                                        {/* <div className="label-float">
                                            <input type="password" onChange={(e) => {setPassword(e.target.value)}} value={Password} />
                                            <input type="submit" onClick={LoginApi} hidden />
                                            <label>Password</label>
                                        </div> */}
                                        <div className="text-center">
                                            <div className="col-xs-12 p-b-20">
                                                <button className="btn btn-block btn-lg btn-info btn-rounded text-white" disabled={Disable} onClick={MobileOtpApi}>Send Otp</button>
                                            </div>
                                        </div>
                                        {/* <div className="label-float">
                                            <input type={password}onChange={onPasswordChange}value={passwordInput}  placeholder=" "/>
                                            <label>Enter password </label>
                                        </div> */}

                                        {/* <Button onClick={toggle} className='eyeopner'>
                                                {password === "password" ? (
                                                <FontAwesomeIcon icon={faEye} className='eyeclr' />
                                                ) : (
                                                <FontAwesomeIcon icon={faEyeSlash} className='eyeclr' />
                                                )}
                                        </Button> */}
                                    </div>
                                </div>
                                {/* <div className="form-group login-btm">
                                    <div className="col-xs-12">

                                    <input type={password}onChange={onPasswordChange}value={passwordInput}          placeholder="Enter password" name="password" classNameName="form-control"
                />
                <Button onClick={toggle} classNameName='eyeopner'>
                {password === "password" ? (
                <FontAwesomeIcon icon={faEye} classNameName='eyeclr' />
                ) : (
                <FontAwesomeIcon icon={faEyeSlash} classNameName='eyeclr' />
                )}
                </Button>


                                        </div>
                                </div>
                                <div className="form-group row  login-btm">
                                    <div className="col-md-12">
                                        <div className="checkbox checkbox-info pull-left p-t-0">
                                            <input id="checkbox-signup" type="checkbox" className="filled-in chk-col-light-blue" />
                                            <label for="checkbox-signup"> Remember me </label>
                                        </div> <a href="javascript:void(0)" id="to-recover" className="text-dark pull-right">   <FontAwesomeIcon icon={faLock} size="xs" />&nbsp; Forgot password? </a> </div>
                                </div> */}
                                
                                {/* <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 m-t-10 text-center">
                                        <div className="social social_dev">
                                            <a href="javascript:void(0)" className="btn  btn-facebook divsocial1" data-toggle="tooltip" title="" data-original-title="Login with Facebook"> <FontAwesomeIcon icon={faFacebookF} /> </a>
                                            <a href="javascript:void(0)" className="btn btn-googleplus divsocial2" data-toggle="tooltip" title="" data-original-title="Login with Google">  <FontAwesomeIcon icon={faGooglePlusG} /> </a>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="form-group m-b-0">
                                    <div className="col-sm-12 text-center">
                                        Don't have an account? <Link to={"/Registration"} className="text-info m-l-5"><b>Sign Up</b></Link>
                                    </div>
                                </div> */}
                            </div>
                            <form className="form-horizontal" id="recoverform" action="index.html">
                                <div className="form-group ">
                                    <div className="col-xs-12">
                                        <h3>Recover Password</h3>
                                        <p className="text-muted">Enter your Email and instructions will be sent to you! </p>
                                    </div>
                                </div>
                                <div className="form-group ">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="text" required="" placeholder="Email" /> </div>
                                </div>
                                <div className="form-group text-center m-t-20">
                                    <div className="col-xs-12">
                                        <button className="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Reset</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    </div>
                        </div>
                    </div>
                    }

           
        </div>

       <p style={{color:'#ffffff', textAlign: 'center', marginTop: '-26px', marginBottom: '0px', fontWeight: '500'}}>  CuroNext © All Rights Reserved. 2024 </p>
            </>

    )
  }
  export default DeleteAccount